import { BuyEditProvider } from '@/contexts/BuyEditContext';
import { CreateEditBuyForm } from '@/components/Pages/Buys/Create/CreateEditBuyForm';
import { createFileRoute } from '@tanstack/react-router';
import { Link } from '@tanstack/react-router';
import { Stack, Breadcrumbs } from '@mui/joy';

export const Route = createFileRoute('/_protected/buys/create')({
  component: CreateBuy,
});

function CreateBuy() {
  return (
    <>
      <Stack direction='row' justifyContent='space-between'>
        <Breadcrumbs size='sm'>
          <Link to='/buys'>Compras</Link>
        </Breadcrumbs>
      </Stack>

      <BuyEditProvider>
        <CreateEditBuyForm isCreate />
      </BuyEditProvider>
    </>
  );
}
